import type { Network } from '#dn-types/network.ts';

/**
 * Managed lighthouses (MTLH) are IPv6-only, and v1 networks are IPv4-only — so a v1 network can
 * never run managed lighthouses, regardless of its `disableManagedLighthouses` value. Eligibility
 * is "not the legacy v1 network": we check `certVersion !== 1` rather than `=== 2` so a future
 * IPv6-capable v3 stays eligible without a code change here. Single source of truth for "can this
 * network use MTLH". (Whether a network currently HAS a managed lighthouse comes from
 * GET /v1/managed-lighthouses — see useSuspenseManagedLighthouses.)
 */
export function isNetworkMtlhEligible(network: Pick<Network, 'certVersion'>): boolean {
  return network.certVersion !== 1;
}
